/* ==============================================================================================
 * SEARCH AREA
 * ============================================================================================== */

var Sushi;

(function (Sushi) {
	"use strict";

	var searchContainer = document.querySelector("[data-feature=searchArea]");
	var searchResultsContainer = document.querySelector("[data-feature=searchResultsArea]");

	if (!searchContainer || !searchResultsContainer) {
		return;
	}

	var formContainers = searchContainer.querySelectorAll("[data-search-area-form]");
	var collapseTriggers = document.querySelectorAll("[data-search-area-collapse-trigger]");
	var expandTriggers = document.querySelectorAll("[data-search-area-expand-trigger]");

	var handleSearchCollapse = function () {
		Sushi.Dom.addClass(searchContainer, "c-searchArea--collapsed");
		Sushi.Dom.addClass(searchResultsContainer, "c-searchResultsArea--showResults");
		Sushi.Dom.removeClass(expandTriggers, "_dn");
		Sushi.Util.triggerWindowResize();
	};

	var handleSearchExpand = function () {
		Sushi.Dom.removeClass(searchContainer, "c-searchArea--collapsed");
		Sushi.Dom.removeClass(searchResultsContainer, "c-searchResultsArea--showResults");
		Sushi.Dom.addClass(expandTriggers, "_dn");
		Sushi.Util.triggerWindowResize();
	};

	Sushi.Events(formContainers).on("submit", function (event) {
		event.preventDefault();
		handleSearchCollapse();
	});

	Sushi.Events(expandTriggers).on("click", function () {
		handleSearchExpand();
	});

	Sushi.Events(collapseTriggers).on("click", function () {
		handleSearchCollapse();
	});

})(Sushi || (Sushi = {}));
